import { Howler, Howl } from 'howler';
import eventHub from './eventHub';

const audio = {
  sounds: [
    {
      id: 'background',
      file: '/assets/audio/background.mp3',
      ref: null,
      loop: true,
      volume: 0.2,
    },
    {
      id: 'weeee',
      file: '/assets/audio/weeee.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'yummi',
      file: '/assets/audio/yummi.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'powerup',
      file: '/assets/audio/powerup.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'error',
      file: '/assets/audio/error.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'powerdown',
      file: '/assets/audio/powerdown.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'gameover',
      file: '/assets/audio/gameover.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'click',
      file: '/assets/audio/click.mp3',
      ref: null,
      loop: false,
      volume: 0.4,
    },
  ],

  init() {
    audio.sounds.forEach((s) => {
      s.ref = new Howl({ src: [s.file], loop: s.loop, volume: s.volume });
      s.promise = () => new Promise((resolve) => s.ref.once('load', resolve));
    });

    eventHub.$on('unmute', audio.unmute);
    eventHub.$on('mute', audio.mute);
  },

  load() {
    return new Promise((resolve) => {
      const promises = [];
      audio.sounds.forEach((s) => promises.push(s.promise()));

      Promise.all(promises).then(resolve);
    });
  },

  get(id) {
    return audio.sounds.find((s) => s.id === id).ref;
  },

  play(id) {
    audio.get(id).play();
  },

  stop(id) {
    audio.get(id).pause();
  },

  mute() {
    Howler.mute(true);
  },

  unmute() {
    Howler.mute(false);
  },
};

export default audio;
